module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_3_pc.a5f3bcbc.jpg";